import { InputAdornment } from '@mui/material';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MessageBar from '../../atoms/MessageBar';
import dayjs from 'dayjs';
import { usePaymentManager } from '../../../hooks/paymentManager.hook';
import { useState, useEffect } from 'react';

// paymentMade: false / array with payment_date, payment_amount
// student_id
// student_name (for logging)
// refetch: refresh data upon successful payment
// fa: financial assistance flag

const PaymentManager_v2 = ({
  paymentMade = false,
  paymentHistory = [],
  student_id,
  student_name = '',
  refetch = '',
  fa,
}) => {
  const { makePayment, paymentLoader, handleFAUpdate } = usePaymentManager();
  const [faState, setFaState] = useState(0);

  useEffect(() => {
    setFaState(+fa);
  }, [fa]);

  return (
    <>
      {paymentMade ? (
        <MessageBar
          testid='payment-message-text'
          type='success'
          msg={`Payment of S\$${paymentMade.payment_amount} made on ${dayjs(
            paymentMade.payment_date
          ).format('DD MMMM YY')}`}
        />
      ) : (
        <>
          {!!faState ? (
            ''
          ) : (
            <TextField
              label='Amount'
              placeholder='0.00'
              id={`paymentValueField_` + student_id}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>$</InputAdornment>
                ),
                endAdornment: (
                  <Button
                    variant={paymentLoader ? 'disabled' : 'contained'}
                    id='paymentSubmitButton'
                    onClick={() =>
                      makePayment(student_id, student_name, refetch)
                    }
                    size='large'
                  >
                    {paymentLoader ? 'Updating' : 'Save'}
                  </Button>
                ),
              }}
            />
          )}
        </>
      )}

      <div className='pb-5 pt-5'>
        <div className='font-bold'>Payment History</div>
        {paymentHistory.length ? (
          <ul className='list-inside list-disc'>
            {paymentHistory.map((payment, index) => (
              <li key={index}>
                ({payment.payment_year !== null ? payment.payment_year : ' - '}){' '}
                {dayjs(payment.payment_date).format('DD MMM YY')} - S$
                {payment.payment_amount}
              </li>
            ))}
          </ul>
        ) : (
          <div>No payment history available.</div>
        )}
      </div>

      <FormGroup className=''>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!faState}
              color='primary'
              inputProps={{ 'aria-label': 'controlled' }}
              onClick={() => {
                handleFAUpdate(student_id, !faState);
                setFaState(!faState);
              }}
            />
          }
          label='Financial Assistance '
        />
      </FormGroup>
    </>
  );
};

export default PaymentManager_v2;
